import { MifeParcel } from '@/components/MifeParcel';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_unauthenticated/(auth-routes)/signup')({
  component: () => <MifeParcel />,
});
